"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var kendo_react_common_1 = require("@progress/kendo-react-common");
/**
 * Represents the KendoReact Hint component.
 * Render the hint text that will be shown underneath the form editor.
 */
exports.Hint = function (props) {
    var hintClassName = kendo_react_common_1.classNames({
        'k-form-hint': true,
        'k-text-start': props.direction === 'start',
        'k-text-end': props.direction === 'end'
    }, props.className);
    return (React.createElement("div", { id: props.id, style: props.style, className: hintClassName }, props.children));
};
exports.Hint.propTypes = {
    id: PropTypes.string,
    direction: PropTypes.oneOf(['start', 'end']),
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.node
    ]),
    style: PropTypes.object,
    className: PropTypes.string
};
exports.Hint.defaultProps = {
    direction: 'start'
};
exports.Hint.displayName = 'KendoReactHint';
//# sourceMappingURL=Hint.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-labels@3.18.0_@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_react_nyscn3hbomdbkpk4tysqx62gaa/~/@progress/kendo-react-labels/dist/npm/Hint.js
// module id = 6616
// module chunks = 0